module.exports = __webpack_public_path__ + "static/media/matic.e71c420f.png";